import algoliasearch from "algoliasearch";
import { getEnvConfig } from "./core";

const algoliaApplicationId = getEnvConfig("VITE_ALGOLIA_APPLICATION_ID") || getEnvConfig("REACT_APP_ALGOLIA_APPLICATION_ID");
const algolia = getEnvConfig("VITE_ALGOLIA") || getEnvConfig("REACT_APP_ALGOLIA");
export const algoliaSearchClient = algoliasearch(algoliaApplicationId, algolia);
